import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import cartSlice from './slices/cartSlice';
import productsSlice from './slices/productsSlice';
import vehicleSlice from './slices/vehicleSlice';
import watchlistSlice from './slices/watchlistSlice';

// Create a simple logger middleware
const logger = (store) => (next) => (action) => {
  console.log('Dispatching:', action.type);
  return next(action);
};

// Create store with basic configuration
const store = configureStore({
  reducer: {
    auth: authSlice,
    cart: cartSlice,
    products: productsSlice,
    vehicle: vehicleSlice,
    watchlist: watchlistSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== 'production',
});

// Setup API interceptors
import('../services/apiSetup')
  .then(module => module.default(store))
  .catch(error => console.error('Failed to setup API interceptors:', error));

export default store;
